import { Box, styled as muiStyled, BoxProps } from '@mui/material';

export const BoxAbsolute = muiStyled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  border-radius: 12px;
` as React.ComponentType<BoxProps>;
